import { render } from "./SabyIcon.vue?vue&type=template&id=3210c0be"
import script from "./SabyIcon.vue?vue&type=script&lang=js"
export * from "./SabyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__